var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBold, faCircle, faSquare } from "@fortawesome/pro-solid-svg-icons";
import { faItalic, faUnderline, faAlignLeft, faAlignCenter, faAlignRight, } from "@fortawesome/pro-regular-svg-icons";
import { Fields, ColorSwatch, SimpleSelectField, ControlGroup, Control, Button, ErrorList, } from "../Form";
import { AbsoluteOverlay } from "../Indicators";
import { useDefaultValueListener } from "../../hooks";
import { camelCase } from "lodash";
import { TextField } from "../Form/TextField";
var fonts = [
    "Default",
    "Comic",
    "Courier",
    "Georgia",
    "Helvetica",
    "Helvetica Neue",
    "Impact",
    "Lucida",
    "Tahoma",
    "Trebuchet MS",
    "Times",
    "Verdana",
];
var fontSizes = Array(5)
    .fill(0)
    .map(function (_, i) { return i * 2 + 8; });
var schema = yup.object({
    name: yup.string().required(),
    borderRadius: yup.string(),
    fill: yup.string(),
    font: yup.string(),
    fontSize: yup.string(),
    fontStyle: yup.string(),
    outlineColor: yup.string(),
    textColor: yup.string(),
    textAlignment: yup.string(),
});
export var StyleForm = function (_a) {
    var _b, _c, _d;
    var externalSubmitHandler = _a.onSubmit, loading = _a.loading, defaultValues = _a.defaultValues, submitTitle = _a.submitTitle, presetColorOptions = _a.presetColorOptions;
    var _e = useForm({
        resolver: yupResolver(schema),
        mode: "onBlur",
    }), formState = _e.formState, handleSubmit = _e.handleSubmit, register = _e.register, formErrors = _e.formState.errors, watch = _e.watch, setError = _e.setError, reset = _e.reset, setValue = _e.setValue;
    useDefaultValueListener(defaultValues, reset);
    var _f = watch([
        "fontStyle",
        "textAlignment",
        "borderRadius",
        "fillColor",
        "textColor",
        "outlineColor",
    ]), fontStyle = _f[0], textAlignment = _f[1], borderRadius = _f[2], fillColor = _f[3], textColor = _f[4], outlineColor = _f[5];
    var colorSwatches = [
        {
            label: "fill",
            name: "fillColor",
            defaultValue: (_b = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.fillColor) !== null && _b !== void 0 ? _b : "#d6d6d6",
            value: fillColor,
        },
        {
            label: "outline",
            name: "outlineColor",
            defaultValue: (_c = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.outlineColor) !== null && _c !== void 0 ? _c : "#2d3748",
            value: outlineColor,
        },
        {
            label: "text",
            name: "textColor",
            defaultValue: (_d = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.textColor) !== null && _d !== void 0 ? _d : "#1a202c",
            value: textColor,
        },
    ];
    var handleFormSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, keys;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (externalSubmitHandler === null || externalSubmitHandler === void 0 ? void 0 : externalSubmitHandler(data))];
                case 1:
                    _a = ((_b = (_c.sent())) !== null && _b !== void 0 ? _b : {}).errors, errors = _a === void 0 ? {} : _a;
                    keys = Object.keys(errors);
                    if (keys.length) {
                        keys.map(function (key) {
                            return setError(camelCase(key), {
                                message: errors[key],
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); });
    return (_jsxs("form", __assign({ onSubmit: handleFormSubmit }, { children: [_jsxs(Fields, __assign({ register: register, grow: true }, { children: [_jsx(TextField, { name: "name", label: "Name", required: true, grow: true }, void 0), _jsx(Fields, __assign({ nested: true, grow: true }, { children: colorSwatches.map(function (_a) {
                            var label = _a.label, name = _a.name, defaultValue = _a.defaultValue, value = _a.value;
                            return (_jsx(ColorSwatch, { label: label, name: name, defaultValue: defaultValue, colors: presetColorOptions, value: value, onChange: function (value) {
                                    setValue(name, value);
                                }, selfControllable: true }, label));
                        }) }), void 0), colorSwatches.map(function (_a) {
                        var name = _a.name;
                        return (_jsx("input", { type: "hidden", name: name }, name));
                    }), _jsxs(Fields, __assign({ nested: true }, { children: [_jsx(SimpleSelectField, { name: "font", label: "font", options: fonts }, void 0), _jsx(SimpleSelectField, { name: "fontSize", label: "size", options: fontSizes }, void 0)] }), void 0), _jsxs(Fields, __assign({ nested: true }, { children: [_jsxs(ControlGroup, __assign({ name: "fontStyle", label: "font style", selected: fontStyle }, { children: [_jsx(Control, __assign({ value: "bold", type: "checkbox" }, { children: _jsx(FontAwesomeIcon, { icon: faBold }, void 0) }), void 0), _jsx(Control, __assign({ value: "italic", type: "checkbox" }, { children: _jsx(FontAwesomeIcon, { icon: faItalic }, void 0) }), void 0), _jsx(Control, __assign({ value: "underline", type: "checkbox" }, { children: _jsx(FontAwesomeIcon, { icon: faUnderline }, void 0) }), void 0)] }), void 0), _jsxs(ControlGroup, __assign({ name: "textAlignment", label: "text alignment", selected: textAlignment }, { children: [_jsx(Control, __assign({ value: "left" }, { children: _jsx(FontAwesomeIcon, { icon: faAlignLeft }, void 0) }), void 0), _jsx(Control, __assign({ value: "center" }, { children: _jsx(FontAwesomeIcon, { icon: faAlignCenter }, void 0) }), void 0), _jsx(Control, __assign({ value: "right" }, { children: _jsx(FontAwesomeIcon, { icon: faAlignRight }, void 0) }), void 0)] }), void 0), _jsxs(ControlGroup, __assign({ name: "borderRadius", label: "Shape", selected: borderRadius }, { children: [_jsx(Control, __assign({ value: "round" }, { children: _jsx(FontAwesomeIcon, { icon: faCircle }, void 0) }), void 0), _jsx(Control, __assign({ value: "square" }, { children: _jsx(FontAwesomeIcon, { icon: faSquare }, void 0) }), void 0)] }), void 0)] }), void 0), _jsx(ErrorList, { errors: formErrors }, void 0), _jsx(Button, __assign({ type: "submit", className: "mt-2 w-full" }, { children: submitTitle !== null && submitTitle !== void 0 ? submitTitle : "Submit" }), void 0)] }), void 0), loading ? _jsx(AbsoluteOverlay, {}, void 0) : null] }), void 0));
};
